import { Component, Directive } from "@angular/core";
import { AbstractControl, FormControl, UntypedFormGroup, Validators } from "@angular/forms";
import jwt_decode from "jwt-decode";
import { Observable } from "rxjs";

import { HeadingModel } from "../heading-widget/model/heading-widget.model";
import { SummaryModel } from "../summary/model/summary.model";

@Directive()
export class BaseComponent {
  componentName: string;

  constructor() { }

  isEmpty(obj: Record<string, any>): boolean {
    return Object.keys(obj).length === 0;
  }

  capitalizeFirstLetter(stringToCapitalize): any {
    return (
      stringToCapitalize.charAt(0).toUpperCase() + stringToCapitalize.slice(1)
    );
  }

  defineTitleAndDescriptionWidgetObj(name?: string): HeadingModel {
    return { name: name ? name : this.componentName, class: "title-page" };
  }

  validateForm(form: UntypedFormGroup): boolean {
    if (!form.valid) {
      /* if you are using angular 8 or above, you can just do form.markAllAsTouched() which will touch
           all the fields without having to loop through all the fields and mark it as touched.
        */
      // tslint:disable-next-line: forin
      for (const i in form.controls) {
        form.controls[i].markAsTouched();
      }
      return false;
    } else {
      return true;
    }
  }

  validatorsPassword(): Validators {
    return (
      // tslint:disable-next-line: no-unused-expression
      Validators.required,
      Validators.pattern(
        `^((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()_+|~\\-\\=\\\\{\\}\\[\\]\\:";'<>\\/])).{0,100}$`
      )
    );
  }

  validatorsAldPassword() {
    return (
      // tslint:disable-next-line: no-unused-expression
      Validators.required,
      Validators.pattern(
        `^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.]).{8,}$`
      )
    );
  }

  getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch (Error) {
      return null;
    }
  }

  getAliasTransaletAndCapitalizedFirstLetter(alias) {
    return this.capitalizeFirstLetter(alias);
  }

  checkIfBlockExist(uiSummaryElements: Array<SummaryModel>): boolean {
    return !!uiSummaryElements && uiSummaryElements.length > 0;
  }

  control(form: UntypedFormGroup, controlName: string): AbstractControl {
    const c = form?.get(controlName);
    if (!c) {
      // Restituisco un controllo "dummy" per evitare il crash del template
      return new FormControl();
    }
    return c;
  }
  valueChanges(form: UntypedFormGroup, key: string): Observable<any> {
    return form.controls[key].valueChanges;
  }
}
